module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage4-6f4e028f.jpeg";